import { Heading, FlexProps } from '@chakra-ui/react';

export const Header: React.FC<FlexProps> = ({ children, ...flexProps }) => {
  return (
    <Heading
      as="h1"
      fontSize={{ base: '3xl', md: '6xl' }}
      lineHeight="shorter"
      fontFamily="marketingPage"
      textTransform={'uppercase'}
      mb={{ base: 6, md: 16 }}
      fontWeight="bold"
      {...flexProps}>
      {children}
    </Heading>
  );
};
